import { DENOMINATOR_QUERY_ALIAS } from '@modules/quantify/constants';
import { useGetQuantifyTableEQLFunctions } from '@modules/quantify/hooks/useFetchQuantifyTableData/useGetQuantifyTableEQLFunctions/useGetQuantifyTableEQLFunctions';
import { useGetQuantifyTableJoinClause } from '@modules/quantify/hooks/useFetchQuantifyTableData/useGetQuantifyTableJoinClause';
import { useGetQuantifyBaseEQLProps } from '@modules/quantify/hooks/useGetQuantifyBaseEQLProps';
import { useGetQuantifyDenominatorJoinClause } from '@modules/quantify/hooks/useGetQuantifyDenominatorJoinClause';
import { EQLProps, Join } from 'v2/core/repository/eql/types';

interface UseGetQuantifyTableEQLPropsOptions {
  shouldSkipPaginateFunction?: boolean;
  shouldSkipSearchFunction?: boolean;
  shouldFetchCount?: boolean;
}

export const useGetQuantifyTableEQLProps = ({
  shouldSkipPaginateFunction = false,
  shouldSkipSearchFunction = false,
  shouldFetchCount,
}: UseGetQuantifyTableEQLPropsOptions = {}): Omit<
  EQLProps,
  'sourceDetailsMap'
> => {
  const baseProps = useGetQuantifyBaseEQLProps();
  const tableJoin = useGetQuantifyTableJoinClause({ shouldFetchCount });
  const denominatorJoin = useGetQuantifyDenominatorJoinClause({
    alias: DENOMINATOR_QUERY_ALIAS,
  });
  const functions = useGetQuantifyTableEQLFunctions({
    shouldSkipPaginateFunction,
    shouldSkipSearchFunction,
    shouldFetchCount,
  });

  return {
    ...baseProps,
    joins: [tableJoin, denominatorJoin].filter((item): item is Join =>
      Boolean(item),
    ),
    functions,
  };
};
